export class API 
{
    public static URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

    public static async RequestAsync(
        resource : string, 
        token: string, 
        verb : 'GET' | 'POST' | 'PUT' | 'DELETE', 
        body? : any)
    {

        let headers : HeadersInit = {
            'api-key' : token
        };

        if(body && !(body instanceof FormData))
            headers['Content-Type'] = 'application/json';

        return await fetch(`${API.URL}${resource}`,
            {
                headers: headers,
                method: verb, 
                body: body && body instanceof FormData ? body : JSON.stringify(body)
            });
    }
}